export const videoPlayer = () => ({
    data () {
        return {
            youtubeFormat: 'https://www.youtube.com/embed/:id',
            vimeoFormat: 'https://player.vimeo.com/video/:id'
        }
    },
    computed: {
        placeholder () {
            return 'https://www.youtube.com/watch?v=_NXzezhPgFQ  |  https://vimeo.com/297911183';
        },
    },
	methods: {
		embedVideo (url = '') {
            if (this.isYoutube(url)) {
                return this.youtubeFormat.replace(':id', this.youtubeId(url));
            } else if (this.isVimeo(url)) {
                return this.vimeoFormat.replace(':id', this.vimeoId(url));
            }

            return null;
        },
        validateVideo (url = '') {
            if ((url || '').length == 0) {
                return false;
            }

            return this.isYoutube(url) || this.isVimeo(url);
        },
        isYoutube (url = '') {
            return url.indexOf('.youtube.com/watch?v=') > -1 ||
            url.indexOf('youtu.be') > -1;
        },
        isVimeo (url) {
            return url.indexOf('vimeo.com/') > -1;
        },
        youtubeId (url = '') {
            let id = null;

            //if (url.indexOf('t=') > -1) {
                //url.replace('/\??&?t=[0-9]+/i', 'ff');
            //}
            if (url.indexOf('watch?v=') > -1) {
                id = url.substring(url.indexOf('?v=') + 3, url.indexOf('?v=') + 14);
            } else if (url.indexOf('/embed/') > -1) {
                id = url.substring(url.indexOf('/embed/') + 7, url.indexOf('/embed/') + 18);
            } else if (url.indexOf('youtu.be')) {
                id = url.substring(url.indexOf('youtu.be/') + 9, url.indexOf('youtu.be/') + 20)
            }

            return id.length == 11 ? id : null;
        },
        vimeoId (url = '') {
            let id = null;

            if (url.indexOf('player.vimeo.com/video/') > -1) {
                id = url.substring(url.indexOf('com/video/') + 10);
            } else if (url.indexOf('vimeo.com/') > -1) {
                id = url.substring(url.indexOf('.com/') + 5);

                if (id.includes('/')) {
                    id = id.split('/')[0];
                }
            }
            return id.length > 0 ? id : null;
        }
	}
});
